
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import Product from "@/types/Product";
import ProductChangelog from "@/types/ProductChangelog";
import { defineComponent, PropType } from "vue";
import Button from "@/Components/Buttons/Button.vue";
import Card from "@/Components/General/Card.vue";
import Changelogs from "@/Components/Product/Changelogs.vue";
import Pagination from "@/types/Pagination";
import { Inertia } from "@inertiajs/inertia";
import {Link} from "@inertiajs/inertia-vue3";

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    changelogs: {
      type: Object as PropType<Pagination<ProductChangelog>>,
      required: true,
    },
    field: {
      type: String,
      default: () => "all",
    },
  },
  setup(props) {
    const legacyBaseUrl = `/products/view-product/${props.product.id}/`;

    const printPriceTag = (isSmall = false, isCampaign = false) => {
      Inertia.post(
        route(`products.label.print${isCampaign ? "-campaign" : ""}`),
        {
          isSmall: isSmall,
        }
      );
    };

    return {
      legacyBaseUrl,
      printPriceTag,
    };
  },
  components: {Link, Button, Card, Changelogs },
});
